export default __webpack_public_path__ + "static/media/photo-6@2x.7e18f5ad.png";